// import image file
import { Link } from "react-router-dom";

const PageNone = () => {
    return(
        <div>
            <Link to="/"><p>Page 404</p></Link>
        </div>
    );
}
export default PageNone;